import { createSlice, createAsyncThunk, isAllOf } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import httpService from '../../common/http.service'

export const appCreateCaste = createAsyncThunk('appCaste/appCreateCaste', async params => {
	try {
		const response = await httpService.post('/caste', {}, params)
		if (response?.data) {
			toast.success('Caste created Successfully')
			params.navigate(`/caste`)
		}
		return await response.data
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appGetAllCaste = createAsyncThunk('appCaste/appGetAllCaste', async (params = {}) => {
	try {
		const { page = 1, limit = 10, loading = true, religion, nativeplace, language, caste } = params

		let url = `/caste?page=${page}&limit=${limit}`

		if (religion) url += `&religion=${encodeURIComponent(religion)}`
		if (nativeplace) url += `&nativeplace=${encodeURIComponent(nativeplace)}`
		if (language) url += `&language=${encodeURIComponent(language)}`
		if (caste) url += `&caste=${encodeURIComponent(caste)}`

		const response = await httpService.get(url, {}, {}, { loading })

		return response.data.data
	} catch (error) {
		toast.error(error?.message || 'Failed to fetch caste list')
		throw error
	}
})

export const appUpdateCaste = createAsyncThunk('appCaste/appUpdateCaste', async params => {
	try {
		const response = await httpService.put(
			`/caste/${params.id}`,
			{},
			{
				name: params.name,
				language: params.language,
				nativeplace: params.nativeplace,
				religion: params.religion,
				significance: params.significance,
				gotra: params.gotra,
			},
		)
		if (response.data) {
			if (params.editImage) {
				params.navigate(`/caste/${params?.editImage}/images/list`)
				toast.success('Image is Updated Successfully')
			} else if (params.newImage) {
				params.navigate(`/caste/${params?.newImage}/images/list`)
				toast.success('Image is Created Successfully')
			} else if (params.deleteImage) {
				params.navigate(`/caste/${params?.deleteImage}/images/list`)
				toast.success('Image is removed successfully')
			} else {
				params.navigate('/caste/1')
				toast.success('caste is Updated Successfully')
			}
		}
		return await response.data
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appDeleteCaste = createAsyncThunk('appCaste/appDeleteCaste', async id => {
	try {
		const response = await httpService.delete(`/caste/${id}`)
		if (response?.data) {
			response.data.id = id
			toast.success('Caste Deleted Successfully')
		}
		return await response.data
	} catch (error) {
		toast.error(error?.message)
	}
})

export const appCasteSlice = createSlice({
	name: 'Caste',
	initialState: {
		caste: [],
		slugData: '',
		paginate: '',
		isloder: false,
		isdeleted: false,
	},
	reducers: {
		handleSuggestedLanguage: (state, action) => {
			state.slugData.suggested[action.payload.number].caste[action.payload.index].ischeck = !state
				.slugData.suggested[action.payload.number].caste[action.payload.index].ischeck
			for (let index = 0; index < state.slugData.suggested.length; index++) {
				const element = state.slugData.suggested[index]
				if (element.required) {
					const filterIndex = element.caste.filter(i => i.ischeck)
					if (filterIndex.length) {
						if (element.maximum < filterIndex.length) {
							element.formIsValid = false
							return
						} else {
							element.formIsValid = true
						}
					} else {
						element.formIsValid = false
						return
					}
				} else {
					element.formIsValid = true
				}
			}
		},
	},
	extraReducers: builder => {
		builder.addMatcher(isAllOf(appCreateCaste.fulfilled), (state, action) => {
			state.caste.push(action.payload?.data)
		})
		builder.addMatcher(isAllOf(appDeleteCaste.pending), (state, action) => {
			state.isdeleted = false
		})
		builder.addMatcher(isAllOf(appDeleteCaste.fulfilled), (state, action) => {
			state.isdeleted = true
		})
		builder.addMatcher(isAllOf(appDeleteCaste.rejected), (state, action) => {
			state.isdeleted = false
		})
		builder.addMatcher(isAllOf(appUpdateCaste.fulfilled), (state, action) => {
			const index = state.caste?.findIndex(data => data?._id === action?.payload?.data?._id)
			state.caste[index] = action?.payload?.data
			toast.success(action, 'Caste is Updated Successfully')
		})
		builder.addMatcher(isAllOf(appGetAllCaste.fulfilled), (state, action) => {
			if (action.meta.arg?.isDropdown) {
				state.dropdownCasteList = action.payload?.data
			} else {
				state.caste = action.payload?.data
				const paginate = {
					hasNextPage:
						action?.payload?.pagination?.totalPages > action?.payload?.pagination?.currentPage,
					hasPrevPage: action?.payload?.pagination?.currentPage > 1,
					limit: action?.payload?.pagination?.pageSize,
					nextPage: action?.payload?.pagination?.currentPage + 1,
					page: action?.payload?.pagination?.currentPage,
					pagingCounter:
						(action?.payload?.pagination?.currentPage - 1) * action?.payload?.pagination?.pageSize +
						1,
					prevPage: action?.payload?.pagination?.currentPage - 1,
					totalDocs: action?.payload?.pagination?.totalRecords,
					totalPages: action?.payload?.pagination?.totalPages,
				}
				state.paginate = paginate
			}
			state.isloder = false
		})
	},
})

export const { handleSuggestedLanguage } = appCasteSlice.actions
export default appCasteSlice.reducer
